export default __webpack_public_path__ + "assets/img/avatar-12.0caed83.png";